import { WeatherHurricaneOutlineIcon } from './WeatherHurricaneOutlineIcon';

/**
 * author: Jeff Anders
 * id B5191E73-1C38-4B78-9018-F8216855C61A
 * name weather-hurricane-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-hurricane-outline.svg
 * tags
 * - Weather 
 * - Nature 
 * - Agriculture 
 */
export const CycloneOutlineIcon = WeatherHurricaneOutlineIcon;
export default CycloneOutlineIcon